export default {"src":"/_next/static/media/hdfc_insurance.35b096b1.svg","height":66,"width":112,"blurWidth":0,"blurHeight":0};